import * as React from "react";
import Box from "@mui/material/Box";
import ComingSoon from "../common/ComingSoon";

const Groups: React.FC = () => {
  return (
    <Box>
      <ComingSoon label="Groups" />
    </Box>
  );
};

export default Groups;

